import React, { useRef } from 'react'
import QRCode from 'qrcode.react'
import { links } from '@/constants/avenue-links'
import { CopyOutlined, DownloadOutlined } from '@ant-design/icons'

const App = (props) => {
  const { item = {}, toCopy = () => {}, flag = '' } = props
  const linkRef = useRef(null)
  const link = flag === 'APP' ? links.app : links.wq

  function changeCanvasToPic (name, channel) {
    const canvasImg = document.getElementById('qrCode') // 获取canvas类型的二维码
    const img = new Image()
    img.src = canvasImg.toDataURL('image/png') // 将canvas对象转换为图片的data url
    linkRef.current.href = img.src
    linkRef.current.download = name + '_' + channel + '_' + '二维码' // 图片name
  }

  function toAvenue (item) {
    window.open(link(item.encryptActivityId))
  }

  return (
    <div className='APP-content'>
      <QRCode
        id='qrCode'
        value={link(item.encryptActivityId)}// value参数为生成二维码的链接
        size={135} // 二维码的宽高尺寸
        fgColor='#000000'
      />
      <div className='link-wrap'>
        <div className={flag === 'APP' ? 'link APP' : 'link'} onClick={() => toAvenue(item)}>{link(item.encryptActivityId)}</div>
        <div className='copy' onClick={(e) => toCopy(e, link(item.encryptActivityId))}><CopyOutlined className='icon' />复制链接</div>
        <a download ref={linkRef} className='down'><DownloadOutlined className='icon' /><span onClick={() => changeCanvasToPic(item.name, flag)}>下载二维码</span></a>
      </div>
    </div>
  )
}

export default App
